<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          รายงานความก้าวหน้าที่รับยื่นจาก RSP
        </div>
        <div class="d-flex align-center">
          <Iconify
              icon="ion:document-text"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          <div>รายงานความก้าวหน้าที่รับยื่นจาก RSP</div>
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 370px">
            <div>ภูมิภาค</div>
            <SelectBox
                placeholder="ภาค"
                hide-details
                clearable
                :items="regionMaster"
                @onChange="searchData.region = $event; getFormAList()"
            ></SelectBox>
          </div>

          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
                clearable
                :items="statusMaster"
                @onChange="searchData.status = $event; getFormAList()"
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getFormAList()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <ReportFromRSPItem
            v-for="(item, i) in plans"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
            @onApproved="onApproved(item.id)"
        ></ReportFromRSPItem>
      </div>

      <v-pagination
          class="mt-6"
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          @input="getFormAList"
      ></v-pagination>
      
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SelectBox from "../../components/input/SelectBox"
import ReportFromRSPItem from "../../components/ReportFromRSPItem"
import { mapState } from "vuex"

export default {
  name: "ReportFromRSPList",
  components: {
    TextField,
    SelectBox,
    ReportFromRSPItem
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '7%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '43%'
        },
        {
          name: 'ภูมิภาค',
          width: '10%'
        },
        {
          name: 'ระยะเวลา',
          width: '12%'
        },
        {
          name: 'สถานะ',
          width: '12%'
        },
        {
          name: '',
          width: '4%'
        }
      ],
      plans: [],
      statusMaster: [
          'Submitted',
          'Approved',
      ],
      regionMaster: [
          'ภาคเหนือ',
          'ภาคตะวันออกเฉียงเหนือ',
          'ภาคตะวันออกเฉียงเหนือตอนล่าง',
          'ภาคใต้',
      ],
      searchData: {
        status: null,
        region: null,
        keyword: null,
      },
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getFormAList()
  },
  computed: {
    ...mapState({
      isUSP: state => state.Auth.User.user_type === 'USP',
      isRSP: state => state.Auth.User.user_type === 'RSP'
    })
  },
  methods: {
    async getFormAList (page) {
      let res
      let payload = {
        status: this.searchData.status ?? this.statusMaster.join(','),
        region: this.searchData.region ?? this.regionMaster.join(','),
        keyword: this.searchData.keyword,
        doc_type: 'Progress,Final',
        page: page,
      }

      res = await this.$apiFire('AForm/getFormAList', payload)
      console.log(res)
      this.plans = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    },
    async onApproved (id) {
      let res = await this.$apiFire('AForm/approvedFormA', id)
      console.log(res)
      this.getFormAList()
    }
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>